import { apiBaseUrl } from '@/shared/env'
import { authHeader } from '@/shared/api/client'

function filenameFromDisposition(header: string | null, fallback: string): string {
  if (!header) return fallback
  const match = /filename="([^"]+)"/i.exec(header)
  return match?.[1] ?? fallback
}

function isPdfBytes(buffer: ArrayBuffer): boolean {
  const bytes = new Uint8Array(buffer)
  return (
    bytes.length >= 4 &&
    bytes[0] === 0x25 &&
    bytes[1] === 0x50 &&
    bytes[2] === 0x44 &&
    bytes[3] === 0x46
  )
}

/** Unduh matriks distribusi hari ini (produk × toko) sebagai PDF. */
export async function downloadTodayDispatchPdf(): Promise<void> {
  const res = await fetch(`${apiBaseUrl}/kitchen/deliveries/today/export`, {
    headers: authHeader(),
    cache: 'no-store',
  })

  if (!res.ok) {
    let message = `Gagal unduh PDF (${res.status})`
    try {
      const body = (await res.json()) as { error?: string }
      if (body.error) message = body.error
    } catch {
      // response bukan JSON
    }
    throw new Error(message)
  }

  const buffer = await res.arrayBuffer()
  if (!isPdfBytes(buffer)) {
    throw new Error('File unduhan tidak valid. Restart backend server lalu coba lagi.')
  }

  const filename = filenameFromDisposition(
    res.headers.get('Content-Disposition'),
    `distribusi-${new Date().toISOString().slice(0, 10)}.pdf`,
  )

  const blob = new Blob([buffer], { type: 'application/pdf' })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename
  anchor.rel = 'noopener'
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  URL.revokeObjectURL(url)
}
